<script>

import DraggableComponent from "@js/components/Dragable/DraggableComponent.vue";
import ProductFeature from "@js/components/Sections/Product/Components/ProductFeature.vue";
import TextAccordion from "@js/components/Sections/TextBlocks/TextAccordion.vue";
import {useProductStore} from "@js/store/ProductStore.js";

export default {
    name: "ProductDescription",
    components: {TextAccordion, ProductFeature, DraggableComponent},
    props:{
        product: {
            required: true,
            type: Object,
        }
    },
    data() {
        return {
            activeTab: 'description',
            tabs: {
                description: 'description',
                shipping: 'shipping',
                features: 'features',
            },
        };
    },
    methods: {
        changeTab(tab) {
            this.activeTab = tab;
        },
    },
    watch: {
        'productStore.product': {
            handler: function (value) {
                if (!this.productStore.product.product_seo) {
                    this.changeTab(this.tabs.shipping);
                }
            },
            deep: true,
        },
    },
    setup() {
        const productStore = useProductStore()

        return {productStore}
    }
};
</script>

<template>
    <div>
        <div class="flex justify-start overflow-hidden">
            <DraggableComponent>
                <ul class="list-scroll flex flex-nowrap whitespace-nowrap overflow-x-auto overflow-y-hidden list-none space-x-10 ps-5 pe-5">
                    <li :class="{
                        'font-bold border-b-indigo-600': activeTab === tabs.description,
                        'font-medium border-b-transparent': activeTab !== tabs.description,
                      }"
                        @click.prevent="changeTab(tabs.description)"
                        class="cursor-pointer pb-2 border-b-2 hover:border-b-indigo-600 transition">
                        Описание
                    </li>
                    <li :class="{
                        'font-bold border-b-indigo-600': activeTab === tabs.shipping,
                        'font-medium border-b-transparent': activeTab !== tabs.shipping,
                      }"
                        @click.prevent="changeTab(tabs.shipping)"
                        class="cursor-pointer pb-2 border-b-2 hover:border-b-indigo-600 transition">
                        Доставка
                    </li>
                    <li :class="{
                        'font-bold border-b-indigo-600': activeTab === tabs.features,
                        'font-medium border-b-transparent': activeTab !== tabs.features,
                      }"
                        @click.prevent="changeTab(tabs.features)"
                        class="cursor-pointer pb-2 border-b-2 hover:border-b-indigo-600 transition">
                        Все характеристики
                    </li>
                </ul>
            </DraggableComponent>
        </div>
        <div class="border border-gray-300 rounded-xl p-2 md:p-8">
            <div v-show="activeTab === tabs.description">
                <div v-if="product.media.description">
                    <TextAccordion :minHeight="285">
                        <div class="flex flex-col gap-1 bbp"
                             v-html="product.media.description"></div>
                    </TextAccordion>
                </div>
                <div v-else class="font-bold">
                    Описания пока нет
                </div>
            </div>
            <div v-show="activeTab === tabs.shipping">
                <TextAccordion :minHeight="285">
                    <div class="text-sm p-5 md:p-0">
                        <p class="mb-1">
                            Производственный комбинат «Дорожные Плиты» осуществляет доставку ЖБИ-продукции по Москве,
                            включая зоны внутри Третьего транспортного кольца (ТТК) и Садового кольца (СК), а также по
                            всей Московской области. Для транспортировки используется собственный автопарк, включающий
                            грузовые автомобили импортного производства MAN и SCANIA с грузоподъемностью 5, 10, 20 и 40
                            тонн.
                        </p>
                        <p class="mb-1">
                            Кроме доставки по Москве и Московской области, мы оперативно обеспечиваем поставку
                            ЖБИ-изделий в соседние регионы:
                        </p>
                        <ul class=" text-gray-500 list-disc list-outside ps-5 mb-3">
                            <li>Ивановская область</li>
                            <li>Липецкая область</li>
                            <li>Орловская область</li>
                            <li>Тульская область</li>
                            <li>Белгородская область</li>
                            <li>Владимирская область</li>
                            <li>Калужская область</li>
                            <li>Курская область</li>
                            <li>Тамбовская область</li>
                            <li>Брянская область</li>
                            <li>Ярославская область</li>
                            <li>Рязанская область</li>
                            <li>Смоленская область</li>
                            <li>Воронежская область</li>
                            <li>Костромская область</li>
                            <li>Тверская область</li>
                        </ul>
                        <p class="text-xl font-bold mb-3">
                            Условия оплаты
                        </p>
                        <p class="mb-3">
                            Мы предлагаем удобные варианты расчетов для наших клиентов:
                        </p>
                        <ul class="text-gray-500 list-disc list-outside ps-5">
                            <li>
                                Отсрочка платежа по согласованному графику отгрузки
                            </li>
                            <li>
                                Дисконтная программа для строительных компаний
                            </li>
                            <li>
                                Безналичный расчет через банковский перевод
                            </li>
                            <li>
                                Оплата банковскими корпоративными, кредитными и дебетовыми картами
                            </li>
                            <li>
                                Возможность расчета наличными в офисе компании через кассу предприятия
                            </li>
                            <li>
                                Свяжитесь с нами, чтобы уточнить стоимость доставки, сроки поставки и детали оплаты.
                            </li>
                        </ul>
                    </div>
                </TextAccordion>
            </div>
            <div v-show="activeTab === tabs.features">
                <div class="flex flex-col gap-2 p-5 md:p-0">
                    <ProductFeature v-if="product.length"
                                    :description="product.length"
                                    title="Длина, мм"/>
                    <ProductFeature v-if="product.width"
                                    :description="product.width"
                                    title="Ширина, мм"/>
                    <ProductFeature v-if="product.height"
                                    :description="product.height"
                                    title="Высота, мм"/>
                    <ProductFeature v-if="product.weight"
                                    :description="product.weight"
                                    title="Вес, т"/>
                    <template v-if="product.specific_params">
                        <ProductFeature v-if="product.specific_params.inner_diameter"
                                        :description="product.specific_params.inner_diameter"
                                        title="Внутренний диаметр, мм"/>
                        <ProductFeature v-if="product.specific_params.outer_diameter"
                                        :description="product.specific_params.outer_diameter"
                                        title="Внешний диаметр, мм"/>
                        <ProductFeature v-if="product.specific_params.concrete_grade"
                                        :description="product.specific_params.concrete_grade"
                                        title="Марка бетона"/>
                        <ProductFeature v-if="product.specific_params.bore"
                                        :description="product.specific_params.bore"
                                        title="Диаметр отверстия, мм"/>
                        <ProductFeature v-if="product.specific_params.loading_norm"
                                        :description="product.specific_params.loading_norm"
                                        title="Норма загрузки в машину"/>
                        <ProductFeature v-if="product.specific_params.width_or_bore_of_pipe"
                                        :description="product.specific_params.width_or_bore_of_pipe"
                                        title="Ширина/отверстие (для труб)"/>
                        <ProductFeature v-if="product.specific_params.height_or_dimensions"
                                        :description="product.specific_params.height_or_dimensions"
                                        title="Высота/габариты (для труб)"/>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
// Ваши стили
</style>
